import { enumKeyByValue } from '@app/shared/helpers';
import { InstrumentType } from '@app/shared/models/contracts/enums/shared-enums';
import classNames from 'classnames';
import styles from '../pwerm2-widgets/total-equity/total-equity-chart.module.scss';
import { PerYearCapitalStructureChartInstrumentType } from './per-year-capital-structure/per-year-capital-structure-chart-types';

export const getTotalEquityModalBlockClasses = (
  noBlocksSelected: boolean,
  thisBlockSelected: boolean,
  instrument: { type: PerYearCapitalStructureChartInstrumentType; isSweet?: boolean }
) =>
  classNames(styles['graph__item'], {
    [styles['modal-instrument']]: noBlocksSelected || thisBlockSelected,
    [styles['modal-instrument--faded']]: !noBlocksSelected && !thisBlockSelected,
    [styles['graph__item--shareholder-loan']]:
      instrument.type === enumKeyByValue(InstrumentType, InstrumentType.ShareholderLoanNotes),
    [styles['graph__item--sweet']]: instrument.isSweet === true,
    [styles['graph__item--preferred-shares']]:
      instrument.type === enumKeyByValue(InstrumentType, InstrumentType.PreferredShares),
  });

export const getTotalEquityChartBlockClasses = (
  instrumentType: PerYearCapitalStructureChartInstrumentType,
  isSweetEquity?: boolean
) =>
  classNames(styles['graph__item'], styles['graph__item--pre-modal-chart'], {
    [styles['graph__item--shareholder-loan']]:
      instrumentType === enumKeyByValue(InstrumentType, InstrumentType.ShareholderLoanNotes),
    [styles['graph__item--sweet']]: isSweetEquity === true,
    [styles['graph__item--preferred-shares']]:
      instrumentType === enumKeyByValue(InstrumentType, InstrumentType.PreferredShares),
  });
